import confetti from 'canvas-confetti';

export const celebratePoints = (points: number) => {
  // Trigger confetti burst
  const count = points >= 10 ? 100 : 50;
  const spread = points >= 10 ? 100 : 70;

  confetti({
    particleCount: count,
    spread: spread,
    origin: { y: 0.6 },
    colors: ['#FFD700', '#FFA500', '#FF6B6B', '#4ECDC4', '#45B7D1']
  });

  // Trigger haptic feedback if available
  if ('vibrate' in navigator) {
    navigator.vibrate([50, 30, 50]);
  }
};

export const celebrateMilestone = () => {
  // More dramatic celebration for milestones
  const duration = 3000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  const interval: any = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
    });
  }, 250);
};
